import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import './styles.css'

const IconButton = ({ icon, iconType, ...other }) => (
  <button className='iconButton' {...other}>
    <i className={classnames(icon, iconType, 'icon')} />
  </button>
)

export default IconButton

IconButton.propTypes = {
  icon: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/IconButton/index.js